__turbopack_context__.v({
  "align-items_center": "zzVUpa_align-items_center",
  "align-items_desktop_center": "zzVUpa_align-items_desktop_center",
  "align-items_desktop_flexEnd": "zzVUpa_align-items_desktop_flexEnd",
  "align-items_desktop_flexStart": "zzVUpa_align-items_desktop_flexStart",
  "align-items_flexEnd": "zzVUpa_align-items_flexEnd",
  "align-items_flexStart": "zzVUpa_align-items_flexStart",
  "align-items_tablet_center": "zzVUpa_align-items_tablet_center",
  "align-items_tablet_flexEnd": "zzVUpa_align-items_tablet_flexEnd",
  "align-items_tablet_flexStart": "zzVUpa_align-items_tablet_flexStart",
  "background_accent": "zzVUpa_background_accent",
  "background_error": "zzVUpa_background_error",
  "background_info": "zzVUpa_background_info",
  "background_jets-beige": "zzVUpa_background_jets-beige",
  "background_jets-black": "zzVUpa_background_jets-black",
  "background_jets-red": "zzVUpa_background_jets-red",
  "background_link": "zzVUpa_background_link",
  "background_neutral-100": "zzVUpa_background_neutral-100",
  "background_neutral-200": "zzVUpa_background_neutral-200",
  "background_neutral-300": "zzVUpa_background_neutral-300",
  "background_neutral-400": "zzVUpa_background_neutral-400",
  "background_neutral-500": "zzVUpa_background_neutral-500",
  "background_neutral-600": "zzVUpa_background_neutral-600",
  "background_neutral-700": "zzVUpa_background_neutral-700",
  "background_neutral-800": "zzVUpa_background_neutral-800",
  "background_neutral-900": "zzVUpa_background_neutral-900",
  "background_overImage": "zzVUpa_background_overImage",
  "background_overPrimary": "zzVUpa_background_overPrimary",
  "background_primary": "zzVUpa_background_primary",
  "background_primary-highlight": "zzVUpa_background_primary-highlight",
  "background_primary-tint": "zzVUpa_background_primary-tint",
  "background_success": "zzVUpa_background_success",
  "background_warning": "zzVUpa_background_warning",
  "background_white": "zzVUpa_background_white",
  "border-color_accent": "zzVUpa_border-color_accent",
  "border-color_error": "zzVUpa_border-color_error",
  "border-color_info": "zzVUpa_border-color_info",
  "border-color_jets-beige": "zzVUpa_border-color_jets-beige",
  "border-color_jets-black": "zzVUpa_border-color_jets-black",
  "border-color_jets-red": "zzVUpa_border-color_jets-red",
  "border-color_link": "zzVUpa_border-color_link",
  "border-color_neutral-100": "zzVUpa_border-color_neutral-100",
  "border-color_neutral-200": "zzVUpa_border-color_neutral-200",
  "border-color_neutral-300": "zzVUpa_border-color_neutral-300",
  "border-color_neutral-400": "zzVUpa_border-color_neutral-400",
  "border-color_neutral-500": "zzVUpa_border-color_neutral-500",
  "border-color_neutral-600": "zzVUpa_border-color_neutral-600",
  "border-color_neutral-700": "zzVUpa_border-color_neutral-700",
  "border-color_neutral-800": "zzVUpa_border-color_neutral-800",
  "border-color_neutral-900": "zzVUpa_border-color_neutral-900",
  "border-color_overImage": "zzVUpa_border-color_overImage",
  "border-color_overPrimary": "zzVUpa_border-color_overPrimary",
  "border-color_primary": "zzVUpa_border-color_primary",
  "border-color_primary-highlight": "zzVUpa_border-color_primary-highlight",
  "border-color_primary-tint": "zzVUpa_border-color_primary-tint",
  "border-color_success": "zzVUpa_border-color_success",
  "border-color_warning": "zzVUpa_border-color_warning",
  "border-color_white": "zzVUpa_border-color_white",
  "border-radius_full": "zzVUpa_border-radius_full",
  "border-radius_rounded": "zzVUpa_border-radius_rounded",
  "border-radius_standard": "zzVUpa_border-radius_standard",
  "border_dashed": "zzVUpa_border_dashed",
  "border_desktop_dashed": "zzVUpa_border_desktop_dashed",
  "border_desktop_none": "zzVUpa_border_desktop_none",
  "border_desktop_standard": "zzVUpa_border_desktop_standard",
  "border_desktop_thick": "zzVUpa_border_desktop_thick",
  "border_desktop_xthick": "zzVUpa_border_desktop_xthick",
  "border_none": "zzVUpa_border_none",
  "border_standard": "zzVUpa_border_standard",
  "border_tablet_dashed": "zzVUpa_border_tablet_dashed",
  "border_tablet_none": "zzVUpa_border_tablet_none",
  "border_tablet_standard": "zzVUpa_border_tablet_standard",
  "border_tablet_thick": "zzVUpa_border_tablet_thick",
  "border_tablet_xthick": "zzVUpa_border_tablet_xthick",
  "border_thick": "zzVUpa_border_thick",
  "border_xthick": "zzVUpa_border_xthick",
  "box-shadow_desktop_large": "zzVUpa_box-shadow_desktop_large",
  "box-shadow_desktop_medium": "zzVUpa_box-shadow_desktop_medium",
  "box-shadow_desktop_none": "zzVUpa_box-shadow_desktop_none",
  "box-shadow_desktop_small": "zzVUpa_box-shadow_desktop_small",
  "box-shadow_desktop_stickyBottom": "zzVUpa_box-shadow_desktop_stickyBottom",
  "box-shadow_large": "zzVUpa_box-shadow_large",
  "box-shadow_medium": "zzVUpa_box-shadow_medium",
  "box-shadow_none": "zzVUpa_box-shadow_none",
  "box-shadow_small": "zzVUpa_box-shadow_small",
  "box-shadow_stickyBottom": "zzVUpa_box-shadow_stickyBottom",
  "box-shadow_tablet_large": "zzVUpa_box-shadow_tablet_large",
  "box-shadow_tablet_medium": "zzVUpa_box-shadow_tablet_medium",
  "box-shadow_tablet_none": "zzVUpa_box-shadow_tablet_none",
  "box-shadow_tablet_small": "zzVUpa_box-shadow_tablet_small",
  "box-shadow_tablet_stickyBottom": "zzVUpa_box-shadow_tablet_stickyBottom",
  "cursor_not-allowed": "zzVUpa_cursor_not-allowed",
  "cursor_pointer": "zzVUpa_cursor_pointer",
  "display_block": "zzVUpa_display_block",
  "display_desktop_block": "zzVUpa_display_desktop_block",
  "display_desktop_flex": "zzVUpa_display_desktop_flex",
  "display_desktop_inline": "zzVUpa_display_desktop_inline",
  "display_desktop_inlineBlock": "zzVUpa_display_desktop_inlineBlock",
  "display_desktop_none": "zzVUpa_display_desktop_none",
  "display_flex": "zzVUpa_display_flex",
  "display_inline": "zzVUpa_display_inline",
  "display_inlineBlock": "zzVUpa_display_inlineBlock",
  "display_none": "zzVUpa_display_none",
  "display_tablet_block": "zzVUpa_display_tablet_block",
  "display_tablet_flex": "zzVUpa_display_tablet_flex",
  "display_tablet_inline": "zzVUpa_display_tablet_inline",
  "display_tablet_inlineBlock": "zzVUpa_display_tablet_inlineBlock",
  "display_tablet_none": "zzVUpa_display_tablet_none",
  "flex-align_center": "zzVUpa_flex-align_center",
  "flex-align_desktop_center": "zzVUpa_flex-align_desktop_center",
  "flex-align_desktop_left": "zzVUpa_flex-align_desktop_left",
  "flex-align_desktop_right": "zzVUpa_flex-align_desktop_right",
  "flex-align_left": "zzVUpa_flex-align_left",
  "flex-align_right": "zzVUpa_flex-align_right",
  "flex-align_tablet_center": "zzVUpa_flex-align_tablet_center",
  "flex-align_tablet_left": "zzVUpa_flex-align_tablet_left",
  "flex-align_tablet_right": "zzVUpa_flex-align_tablet_right",
  "flex-direction_column": "zzVUpa_flex-direction_column",
  "flex-direction_columnReverse": "zzVUpa_flex-direction_columnReverse",
  "flex-direction_desktop_column": "zzVUpa_flex-direction_desktop_column",
  "flex-direction_desktop_columnReverse": "zzVUpa_flex-direction_desktop_columnReverse",
  "flex-direction_desktop_row": "zzVUpa_flex-direction_desktop_row",
  "flex-direction_desktop_rowReverse": "zzVUpa_flex-direction_desktop_rowReverse",
  "flex-direction_row": "zzVUpa_flex-direction_row",
  "flex-direction_rowReverse": "zzVUpa_flex-direction_rowReverse",
  "flex-direction_tablet_column": "zzVUpa_flex-direction_tablet_column",
  "flex-direction_tablet_columnReverse": "zzVUpa_flex-direction_tablet_columnReverse",
  "flex-direction_tablet_row": "zzVUpa_flex-direction_tablet_row",
  "flex-direction_tablet_rowReverse": "zzVUpa_flex-direction_tablet_rowReverse",
  "flex-grow_0": "zzVUpa_flex-grow_0",
  "flex-grow_1": "zzVUpa_flex-grow_1",
  "flex-grow_desktop_0": "zzVUpa_flex-grow_desktop_0",
  "flex-grow_desktop_1": "zzVUpa_flex-grow_desktop_1",
  "flex-grow_tablet_0": "zzVUpa_flex-grow_tablet_0",
  "flex-grow_tablet_1": "zzVUpa_flex-grow_tablet_1",
  "flex-shrink_0": "zzVUpa_flex-shrink_0",
  "flex-shrink_desktop_0": "zzVUpa_flex-shrink_desktop_0",
  "flex-shrink_tablet_0": "zzVUpa_flex-shrink_tablet_0",
  "flex-wrap_desktop_nowrap": "zzVUpa_flex-wrap_desktop_nowrap",
  "flex-wrap_desktop_wrap": "zzVUpa_flex-wrap_desktop_wrap",
  "flex-wrap_nowrap": "zzVUpa_flex-wrap_nowrap",
  "flex-wrap_tablet_nowrap": "zzVUpa_flex-wrap_tablet_nowrap",
  "flex-wrap_tablet_wrap": "zzVUpa_flex-wrap_tablet_wrap",
  "flex-wrap_wrap": "zzVUpa_flex-wrap_wrap",
  "gap_1": "zzVUpa_gap_1",
  "gap_10": "zzVUpa_gap_10",
  "gap_14": "zzVUpa_gap_14",
  "gap_15": "zzVUpa_gap_15",
  "gap_2": "zzVUpa_gap_2",
  "gap_20": "zzVUpa_gap_20",
  "gap_25": "zzVUpa_gap_25",
  "gap_28": "zzVUpa_gap_28",
  "gap_3": "zzVUpa_gap_3",
  "gap_4": "zzVUpa_gap_4",
  "gap_5": "zzVUpa_gap_5",
  "gap_6": "zzVUpa_gap_6",
  "gap_7": "zzVUpa_gap_7",
  "gap_8": "zzVUpa_gap_8",
  "gap_9": "zzVUpa_gap_9",
  "gap_auto": "zzVUpa_gap_auto",
  "gap_desktop_1": "zzVUpa_gap_desktop_1",
  "gap_desktop_10": "zzVUpa_gap_desktop_10",
  "gap_desktop_14": "zzVUpa_gap_desktop_14",
  "gap_desktop_15": "zzVUpa_gap_desktop_15",
  "gap_desktop_2": "zzVUpa_gap_desktop_2",
  "gap_desktop_20": "zzVUpa_gap_desktop_20",
  "gap_desktop_25": "zzVUpa_gap_desktop_25",
  "gap_desktop_28": "zzVUpa_gap_desktop_28",
  "gap_desktop_3": "zzVUpa_gap_desktop_3",
  "gap_desktop_4": "zzVUpa_gap_desktop_4",
  "gap_desktop_5": "zzVUpa_gap_desktop_5",
  "gap_desktop_6": "zzVUpa_gap_desktop_6",
  "gap_desktop_7": "zzVUpa_gap_desktop_7",
  "gap_desktop_8": "zzVUpa_gap_desktop_8",
  "gap_desktop_9": "zzVUpa_gap_desktop_9",
  "gap_desktop_auto": "zzVUpa_gap_desktop_auto",
  "gap_desktop_gutter": "zzVUpa_gap_desktop_gutter",
  "gap_desktop_none": "zzVUpa_gap_desktop_none",
  "gap_gutter": "zzVUpa_gap_gutter",
  "gap_none": "zzVUpa_gap_none",
  "gap_tablet_1": "zzVUpa_gap_tablet_1",
  "gap_tablet_10": "zzVUpa_gap_tablet_10",
  "gap_tablet_14": "zzVUpa_gap_tablet_14",
  "gap_tablet_15": "zzVUpa_gap_tablet_15",
  "gap_tablet_2": "zzVUpa_gap_tablet_2",
  "gap_tablet_20": "zzVUpa_gap_tablet_20",
  "gap_tablet_25": "zzVUpa_gap_tablet_25",
  "gap_tablet_28": "zzVUpa_gap_tablet_28",
  "gap_tablet_3": "zzVUpa_gap_tablet_3",
  "gap_tablet_4": "zzVUpa_gap_tablet_4",
  "gap_tablet_5": "zzVUpa_gap_tablet_5",
  "gap_tablet_6": "zzVUpa_gap_tablet_6",
  "gap_tablet_7": "zzVUpa_gap_tablet_7",
  "gap_tablet_8": "zzVUpa_gap_tablet_8",
  "gap_tablet_9": "zzVUpa_gap_tablet_9",
  "gap_tablet_auto": "zzVUpa_gap_tablet_auto",
  "gap_tablet_gutter": "zzVUpa_gap_tablet_gutter",
  "gap_tablet_none": "zzVUpa_gap_tablet_none",
  "height_full": "zzVUpa_height_full",
  "height_touchable": "zzVUpa_height_touchable",
  "justify-content_center": "zzVUpa_justify-content_center",
  "justify-content_desktop_center": "zzVUpa_justify-content_desktop_center",
  "justify-content_desktop_flexEnd": "zzVUpa_justify-content_desktop_flexEnd",
  "justify-content_desktop_flexStart": "zzVUpa_justify-content_desktop_flexStart",
  "justify-content_desktop_spaceAround": "zzVUpa_justify-content_desktop_spaceAround",
  "justify-content_desktop_spaceBetween": "zzVUpa_justify-content_desktop_spaceBetween",
  "justify-content_flexEnd": "zzVUpa_justify-content_flexEnd",
  "justify-content_flexStart": "zzVUpa_justify-content_flexStart",
  "justify-content_spaceAround": "zzVUpa_justify-content_spaceAround",
  "justify-content_spaceBetween": "zzVUpa_justify-content_spaceBetween",
  "justify-content_tablet_center": "zzVUpa_justify-content_tablet_center",
  "justify-content_tablet_flexEnd": "zzVUpa_justify-content_tablet_flexEnd",
  "justify-content_tablet_flexStart": "zzVUpa_justify-content_tablet_flexStart",
  "justify-content_tablet_spaceAround": "zzVUpa_justify-content_tablet_spaceAround",
  "justify-content_tablet_spaceBetween": "zzVUpa_justify-content_tablet_spaceBetween",
  "margin-bottom_1": "zzVUpa_margin-bottom_1",
  "margin-bottom_10": "zzVUpa_margin-bottom_10",
  "margin-bottom_14": "zzVUpa_margin-bottom_14",
  "margin-bottom_15": "zzVUpa_margin-bottom_15",
  "margin-bottom_2": "zzVUpa_margin-bottom_2",
  "margin-bottom_20": "zzVUpa_margin-bottom_20",
  "margin-bottom_25": "zzVUpa_margin-bottom_25",
  "margin-bottom_28": "zzVUpa_margin-bottom_28",
  "margin-bottom_3": "zzVUpa_margin-bottom_3",
  "margin-bottom_4": "zzVUpa_margin-bottom_4",
  "margin-bottom_5": "zzVUpa_margin-bottom_5",
  "margin-bottom_6": "zzVUpa_margin-bottom_6",
  "margin-bottom_7": "zzVUpa_margin-bottom_7",
  "margin-bottom_8": "zzVUpa_margin-bottom_8",
  "margin-bottom_9": "zzVUpa_margin-bottom_9",
  "margin-bottom_auto": "zzVUpa_margin-bottom_auto",
  "margin-bottom_desktop_1": "zzVUpa_margin-bottom_desktop_1",
  "margin-bottom_desktop_10": "zzVUpa_margin-bottom_desktop_10",
  "margin-bottom_desktop_14": "zzVUpa_margin-bottom_desktop_14",
  "margin-bottom_desktop_15": "zzVUpa_margin-bottom_desktop_15",
  "margin-bottom_desktop_2": "zzVUpa_margin-bottom_desktop_2",
  "margin-bottom_desktop_20": "zzVUpa_margin-bottom_desktop_20",
  "margin-bottom_desktop_25": "zzVUpa_margin-bottom_desktop_25",
  "margin-bottom_desktop_28": "zzVUpa_margin-bottom_desktop_28",
  "margin-bottom_desktop_3": "zzVUpa_margin-bottom_desktop_3",
  "margin-bottom_desktop_4": "zzVUpa_margin-bottom_desktop_4",
  "margin-bottom_desktop_5": "zzVUpa_margin-bottom_desktop_5",
  "margin-bottom_desktop_6": "zzVUpa_margin-bottom_desktop_6",
  "margin-bottom_desktop_7": "zzVUpa_margin-bottom_desktop_7",
  "margin-bottom_desktop_8": "zzVUpa_margin-bottom_desktop_8",
  "margin-bottom_desktop_9": "zzVUpa_margin-bottom_desktop_9",
  "margin-bottom_desktop_auto": "zzVUpa_margin-bottom_desktop_auto",
  "margin-bottom_desktop_gutter": "zzVUpa_margin-bottom_desktop_gutter",
  "margin-bottom_desktop_none": "zzVUpa_margin-bottom_desktop_none",
  "margin-bottom_gutter": "zzVUpa_margin-bottom_gutter",
  "margin-bottom_none": "zzVUpa_margin-bottom_none",
  "margin-bottom_tablet_1": "zzVUpa_margin-bottom_tablet_1",
  "margin-bottom_tablet_10": "zzVUpa_margin-bottom_tablet_10",
  "margin-bottom_tablet_14": "zzVUpa_margin-bottom_tablet_14",
  "margin-bottom_tablet_15": "zzVUpa_margin-bottom_tablet_15",
  "margin-bottom_tablet_2": "zzVUpa_margin-bottom_tablet_2",
  "margin-bottom_tablet_20": "zzVUpa_margin-bottom_tablet_20",
  "margin-bottom_tablet_25": "zzVUpa_margin-bottom_tablet_25",
  "margin-bottom_tablet_28": "zzVUpa_margin-bottom_tablet_28",
  "margin-bottom_tablet_3": "zzVUpa_margin-bottom_tablet_3",
  "margin-bottom_tablet_4": "zzVUpa_margin-bottom_tablet_4",
  "margin-bottom_tablet_5": "zzVUpa_margin-bottom_tablet_5",
  "margin-bottom_tablet_6": "zzVUpa_margin-bottom_tablet_6",
  "margin-bottom_tablet_7": "zzVUpa_margin-bottom_tablet_7",
  "margin-bottom_tablet_8": "zzVUpa_margin-bottom_tablet_8",
  "margin-bottom_tablet_9": "zzVUpa_margin-bottom_tablet_9",
  "margin-bottom_tablet_auto": "zzVUpa_margin-bottom_tablet_auto",
  "margin-bottom_tablet_gutter": "zzVUpa_margin-bottom_tablet_gutter",
  "margin-bottom_tablet_none": "zzVUpa_margin-bottom_tablet_none",
  "margin-left_1": "zzVUpa_margin-left_1",
  "margin-left_10": "zzVUpa_margin-left_10",
  "margin-left_14": "zzVUpa_margin-left_14",
  "margin-left_15": "zzVUpa_margin-left_15",
  "margin-left_2": "zzVUpa_margin-left_2",
  "margin-left_20": "zzVUpa_margin-left_20",
  "margin-left_25": "zzVUpa_margin-left_25",
  "margin-left_28": "zzVUpa_margin-left_28",
  "margin-left_3": "zzVUpa_margin-left_3",
  "margin-left_4": "zzVUpa_margin-left_4",
  "margin-left_5": "zzVUpa_margin-left_5",
  "margin-left_6": "zzVUpa_margin-left_6",
  "margin-left_7": "zzVUpa_margin-left_7",
  "margin-left_8": "zzVUpa_margin-left_8",
  "margin-left_9": "zzVUpa_margin-left_9",
  "margin-left_auto": "zzVUpa_margin-left_auto",
  "margin-left_desktop_1": "zzVUpa_margin-left_desktop_1",
  "margin-left_desktop_10": "zzVUpa_margin-left_desktop_10",
  "margin-left_desktop_14": "zzVUpa_margin-left_desktop_14",
  "margin-left_desktop_15": "zzVUpa_margin-left_desktop_15",
  "margin-left_desktop_2": "zzVUpa_margin-left_desktop_2",
  "margin-left_desktop_20": "zzVUpa_margin-left_desktop_20",
  "margin-left_desktop_25": "zzVUpa_margin-left_desktop_25",
  "margin-left_desktop_28": "zzVUpa_margin-left_desktop_28",
  "margin-left_desktop_3": "zzVUpa_margin-left_desktop_3",
  "margin-left_desktop_4": "zzVUpa_margin-left_desktop_4",
  "margin-left_desktop_5": "zzVUpa_margin-left_desktop_5",
  "margin-left_desktop_6": "zzVUpa_margin-left_desktop_6",
  "margin-left_desktop_7": "zzVUpa_margin-left_desktop_7",
  "margin-left_desktop_8": "zzVUpa_margin-left_desktop_8",
  "margin-left_desktop_9": "zzVUpa_margin-left_desktop_9",
  "margin-left_desktop_auto": "zzVUpa_margin-left_desktop_auto",
  "margin-left_desktop_gutter": "zzVUpa_margin-left_desktop_gutter",
  "margin-left_desktop_none": "zzVUpa_margin-left_desktop_none",
  "margin-left_gutter": "zzVUpa_margin-left_gutter",
  "margin-left_none": "zzVUpa_margin-left_none",
  "margin-left_tablet_1": "zzVUpa_margin-left_tablet_1",
  "margin-left_tablet_10": "zzVUpa_margin-left_tablet_10",
  "margin-left_tablet_14": "zzVUpa_margin-left_tablet_14",
  "margin-left_tablet_15": "zzVUpa_margin-left_tablet_15",
  "margin-left_tablet_2": "zzVUpa_margin-left_tablet_2",
  "margin-left_tablet_20": "zzVUpa_margin-left_tablet_20",
  "margin-left_tablet_25": "zzVUpa_margin-left_tablet_25",
  "margin-left_tablet_28": "zzVUpa_margin-left_tablet_28",
  "margin-left_tablet_3": "zzVUpa_margin-left_tablet_3",
  "margin-left_tablet_4": "zzVUpa_margin-left_tablet_4",
  "margin-left_tablet_5": "zzVUpa_margin-left_tablet_5",
  "margin-left_tablet_6": "zzVUpa_margin-left_tablet_6",
  "margin-left_tablet_7": "zzVUpa_margin-left_tablet_7",
  "margin-left_tablet_8": "zzVUpa_margin-left_tablet_8",
  "margin-left_tablet_9": "zzVUpa_margin-left_tablet_9",
  "margin-left_tablet_auto": "zzVUpa_margin-left_tablet_auto",
  "margin-left_tablet_gutter": "zzVUpa_margin-left_tablet_gutter",
  "margin-left_tablet_none": "zzVUpa_margin-left_tablet_none",
  "margin-right_1": "zzVUpa_margin-right_1",
  "margin-right_10": "zzVUpa_margin-right_10",
  "margin-right_14": "zzVUpa_margin-right_14",
  "margin-right_15": "zzVUpa_margin-right_15",
  "margin-right_2": "zzVUpa_margin-right_2",
  "margin-right_20": "zzVUpa_margin-right_20",
  "margin-right_25": "zzVUpa_margin-right_25",
  "margin-right_28": "zzVUpa_margin-right_28",
  "margin-right_3": "zzVUpa_margin-right_3",
  "margin-right_4": "zzVUpa_margin-right_4",
  "margin-right_5": "zzVUpa_margin-right_5",
  "margin-right_6": "zzVUpa_margin-right_6",
  "margin-right_7": "zzVUpa_margin-right_7",
  "margin-right_8": "zzVUpa_margin-right_8",
  "margin-right_9": "zzVUpa_margin-right_9",
  "margin-right_auto": "zzVUpa_margin-right_auto",
  "margin-right_desktop_1": "zzVUpa_margin-right_desktop_1",
  "margin-right_desktop_10": "zzVUpa_margin-right_desktop_10",
  "margin-right_desktop_14": "zzVUpa_margin-right_desktop_14",
  "margin-right_desktop_15": "zzVUpa_margin-right_desktop_15",
  "margin-right_desktop_2": "zzVUpa_margin-right_desktop_2",
  "margin-right_desktop_20": "zzVUpa_margin-right_desktop_20",
  "margin-right_desktop_25": "zzVUpa_margin-right_desktop_25",
  "margin-right_desktop_28": "zzVUpa_margin-right_desktop_28",
  "margin-right_desktop_3": "zzVUpa_margin-right_desktop_3",
  "margin-right_desktop_4": "zzVUpa_margin-right_desktop_4",
  "margin-right_desktop_5": "zzVUpa_margin-right_desktop_5",
  "margin-right_desktop_6": "zzVUpa_margin-right_desktop_6",
  "margin-right_desktop_7": "zzVUpa_margin-right_desktop_7",
  "margin-right_desktop_8": "zzVUpa_margin-right_desktop_8",
  "margin-right_desktop_9": "zzVUpa_margin-right_desktop_9",
  "margin-right_desktop_auto": "zzVUpa_margin-right_desktop_auto",
  "margin-right_desktop_gutter": "zzVUpa_margin-right_desktop_gutter",
  "margin-right_desktop_none": "zzVUpa_margin-right_desktop_none",
  "margin-right_gutter": "zzVUpa_margin-right_gutter",
  "margin-right_none": "zzVUpa_margin-right_none",
  "margin-right_tablet_1": "zzVUpa_margin-right_tablet_1",
  "margin-right_tablet_10": "zzVUpa_margin-right_tablet_10",
  "margin-right_tablet_14": "zzVUpa_margin-right_tablet_14",
  "margin-right_tablet_15": "zzVUpa_margin-right_tablet_15",
  "margin-right_tablet_2": "zzVUpa_margin-right_tablet_2",
  "margin-right_tablet_20": "zzVUpa_margin-right_tablet_20",
  "margin-right_tablet_25": "zzVUpa_margin-right_tablet_25",
  "margin-right_tablet_28": "zzVUpa_margin-right_tablet_28",
  "margin-right_tablet_3": "zzVUpa_margin-right_tablet_3",
  "margin-right_tablet_4": "zzVUpa_margin-right_tablet_4",
  "margin-right_tablet_5": "zzVUpa_margin-right_tablet_5",
  "margin-right_tablet_6": "zzVUpa_margin-right_tablet_6",
  "margin-right_tablet_7": "zzVUpa_margin-right_tablet_7",
  "margin-right_tablet_8": "zzVUpa_margin-right_tablet_8",
  "margin-right_tablet_9": "zzVUpa_margin-right_tablet_9",
  "margin-right_tablet_auto": "zzVUpa_margin-right_tablet_auto",
  "margin-right_tablet_gutter": "zzVUpa_margin-right_tablet_gutter",
  "margin-right_tablet_none": "zzVUpa_margin-right_tablet_none",
  "margin-top_1": "zzVUpa_margin-top_1",
  "margin-top_10": "zzVUpa_margin-top_10",
  "margin-top_14": "zzVUpa_margin-top_14",
  "margin-top_15": "zzVUpa_margin-top_15",
  "margin-top_2": "zzVUpa_margin-top_2",
  "margin-top_20": "zzVUpa_margin-top_20",
  "margin-top_25": "zzVUpa_margin-top_25",
  "margin-top_28": "zzVUpa_margin-top_28",
  "margin-top_3": "zzVUpa_margin-top_3",
  "margin-top_4": "zzVUpa_margin-top_4",
  "margin-top_5": "zzVUpa_margin-top_5",
  "margin-top_6": "zzVUpa_margin-top_6",
  "margin-top_7": "zzVUpa_margin-top_7",
  "margin-top_8": "zzVUpa_margin-top_8",
  "margin-top_9": "zzVUpa_margin-top_9",
  "margin-top_auto": "zzVUpa_margin-top_auto",
  "margin-top_desktop_1": "zzVUpa_margin-top_desktop_1",
  "margin-top_desktop_10": "zzVUpa_margin-top_desktop_10",
  "margin-top_desktop_14": "zzVUpa_margin-top_desktop_14",
  "margin-top_desktop_15": "zzVUpa_margin-top_desktop_15",
  "margin-top_desktop_2": "zzVUpa_margin-top_desktop_2",
  "margin-top_desktop_20": "zzVUpa_margin-top_desktop_20",
  "margin-top_desktop_25": "zzVUpa_margin-top_desktop_25",
  "margin-top_desktop_28": "zzVUpa_margin-top_desktop_28",
  "margin-top_desktop_3": "zzVUpa_margin-top_desktop_3",
  "margin-top_desktop_4": "zzVUpa_margin-top_desktop_4",
  "margin-top_desktop_5": "zzVUpa_margin-top_desktop_5",
  "margin-top_desktop_6": "zzVUpa_margin-top_desktop_6",
  "margin-top_desktop_7": "zzVUpa_margin-top_desktop_7",
  "margin-top_desktop_8": "zzVUpa_margin-top_desktop_8",
  "margin-top_desktop_9": "zzVUpa_margin-top_desktop_9",
  "margin-top_desktop_auto": "zzVUpa_margin-top_desktop_auto",
  "margin-top_desktop_gutter": "zzVUpa_margin-top_desktop_gutter",
  "margin-top_desktop_none": "zzVUpa_margin-top_desktop_none",
  "margin-top_gutter": "zzVUpa_margin-top_gutter",
  "margin-top_none": "zzVUpa_margin-top_none",
  "margin-top_tablet_1": "zzVUpa_margin-top_tablet_1",
  "margin-top_tablet_10": "zzVUpa_margin-top_tablet_10",
  "margin-top_tablet_14": "zzVUpa_margin-top_tablet_14",
  "margin-top_tablet_15": "zzVUpa_margin-top_tablet_15",
  "margin-top_tablet_2": "zzVUpa_margin-top_tablet_2",
  "margin-top_tablet_20": "zzVUpa_margin-top_tablet_20",
  "margin-top_tablet_25": "zzVUpa_margin-top_tablet_25",
  "margin-top_tablet_28": "zzVUpa_margin-top_tablet_28",
  "margin-top_tablet_3": "zzVUpa_margin-top_tablet_3",
  "margin-top_tablet_4": "zzVUpa_margin-top_tablet_4",
  "margin-top_tablet_5": "zzVUpa_margin-top_tablet_5",
  "margin-top_tablet_6": "zzVUpa_margin-top_tablet_6",
  "margin-top_tablet_7": "zzVUpa_margin-top_tablet_7",
  "margin-top_tablet_8": "zzVUpa_margin-top_tablet_8",
  "margin-top_tablet_9": "zzVUpa_margin-top_tablet_9",
  "margin-top_tablet_auto": "zzVUpa_margin-top_tablet_auto",
  "margin-top_tablet_gutter": "zzVUpa_margin-top_tablet_gutter",
  "margin-top_tablet_none": "zzVUpa_margin-top_tablet_none",
  "max-width_large": "zzVUpa_max-width_large",
  "max-width_medium": "zzVUpa_max-width_medium",
  "max-width_small": "zzVUpa_max-width_small",
  "max-width_xlarge": "zzVUpa_max-width_xlarge",
  "max-width_xsmall": "zzVUpa_max-width_xsmall",
  "min-width_0": "zzVUpa_min-width_0",
  "overflow_auto": "zzVUpa_overflow_auto",
  "overflow_hidden": "zzVUpa_overflow_hidden",
  "overflow_scroll": "zzVUpa_overflow_scroll",
  "overflow_visible": "zzVUpa_overflow_visible",
  "padding-bottom_1": "zzVUpa_padding-bottom_1",
  "padding-bottom_10": "zzVUpa_padding-bottom_10",
  "padding-bottom_14": "zzVUpa_padding-bottom_14",
  "padding-bottom_15": "zzVUpa_padding-bottom_15",
  "padding-bottom_2": "zzVUpa_padding-bottom_2",
  "padding-bottom_20": "zzVUpa_padding-bottom_20",
  "padding-bottom_25": "zzVUpa_padding-bottom_25",
  "padding-bottom_28": "zzVUpa_padding-bottom_28",
  "padding-bottom_3": "zzVUpa_padding-bottom_3",
  "padding-bottom_4": "zzVUpa_padding-bottom_4",
  "padding-bottom_5": "zzVUpa_padding-bottom_5",
  "padding-bottom_6": "zzVUpa_padding-bottom_6",
  "padding-bottom_7": "zzVUpa_padding-bottom_7",
  "padding-bottom_8": "zzVUpa_padding-bottom_8",
  "padding-bottom_9": "zzVUpa_padding-bottom_9",
  "padding-bottom_auto": "zzVUpa_padding-bottom_auto",
  "padding-bottom_desktop_1": "zzVUpa_padding-bottom_desktop_1",
  "padding-bottom_desktop_10": "zzVUpa_padding-bottom_desktop_10",
  "padding-bottom_desktop_14": "zzVUpa_padding-bottom_desktop_14",
  "padding-bottom_desktop_15": "zzVUpa_padding-bottom_desktop_15",
  "padding-bottom_desktop_2": "zzVUpa_padding-bottom_desktop_2",
  "padding-bottom_desktop_20": "zzVUpa_padding-bottom_desktop_20",
  "padding-bottom_desktop_25": "zzVUpa_padding-bottom_desktop_25",
  "padding-bottom_desktop_28": "zzVUpa_padding-bottom_desktop_28",
  "padding-bottom_desktop_3": "zzVUpa_padding-bottom_desktop_3",
  "padding-bottom_desktop_4": "zzVUpa_padding-bottom_desktop_4",
  "padding-bottom_desktop_5": "zzVUpa_padding-bottom_desktop_5",
  "padding-bottom_desktop_6": "zzVUpa_padding-bottom_desktop_6",
  "padding-bottom_desktop_7": "zzVUpa_padding-bottom_desktop_7",
  "padding-bottom_desktop_8": "zzVUpa_padding-bottom_desktop_8",
  "padding-bottom_desktop_9": "zzVUpa_padding-bottom_desktop_9",
  "padding-bottom_desktop_auto": "zzVUpa_padding-bottom_desktop_auto",
  "padding-bottom_desktop_gutter": "zzVUpa_padding-bottom_desktop_gutter",
  "padding-bottom_desktop_none": "zzVUpa_padding-bottom_desktop_none",
  "padding-bottom_gutter": "zzVUpa_padding-bottom_gutter",
  "padding-bottom_none": "zzVUpa_padding-bottom_none",
  "padding-bottom_tablet_1": "zzVUpa_padding-bottom_tablet_1",
  "padding-bottom_tablet_10": "zzVUpa_padding-bottom_tablet_10",
  "padding-bottom_tablet_14": "zzVUpa_padding-bottom_tablet_14",
  "padding-bottom_tablet_15": "zzVUpa_padding-bottom_tablet_15",
  "padding-bottom_tablet_2": "zzVUpa_padding-bottom_tablet_2",
  "padding-bottom_tablet_20": "zzVUpa_padding-bottom_tablet_20",
  "padding-bottom_tablet_25": "zzVUpa_padding-bottom_tablet_25",
  "padding-bottom_tablet_28": "zzVUpa_padding-bottom_tablet_28",
  "padding-bottom_tablet_3": "zzVUpa_padding-bottom_tablet_3",
  "padding-bottom_tablet_4": "zzVUpa_padding-bottom_tablet_4",
  "padding-bottom_tablet_5": "zzVUpa_padding-bottom_tablet_5",
  "padding-bottom_tablet_6": "zzVUpa_padding-bottom_tablet_6",
  "padding-bottom_tablet_7": "zzVUpa_padding-bottom_tablet_7",
  "padding-bottom_tablet_8": "zzVUpa_padding-bottom_tablet_8",
  "padding-bottom_tablet_9": "zzVUpa_padding-bottom_tablet_9",
  "padding-bottom_tablet_auto": "zzVUpa_padding-bottom_tablet_auto",
  "padding-bottom_tablet_gutter": "zzVUpa_padding-bottom_tablet_gutter",
  "padding-bottom_tablet_none": "zzVUpa_padding-bottom_tablet_none",
  "padding-left_1": "zzVUpa_padding-left_1",
  "padding-left_10": "zzVUpa_padding-left_10",
  "padding-left_14": "zzVUpa_padding-left_14",
  "padding-left_15": "zzVUpa_padding-left_15",
  "padding-left_2": "zzVUpa_padding-left_2",
  "padding-left_20": "zzVUpa_padding-left_20",
  "padding-left_25": "zzVUpa_padding-left_25",
  "padding-left_28": "zzVUpa_padding-left_28",
  "padding-left_3": "zzVUpa_padding-left_3",
  "padding-left_4": "zzVUpa_padding-left_4",
  "padding-left_5": "zzVUpa_padding-left_5",
  "padding-left_6": "zzVUpa_padding-left_6",
  "padding-left_7": "zzVUpa_padding-left_7",
  "padding-left_8": "zzVUpa_padding-left_8",
  "padding-left_9": "zzVUpa_padding-left_9",
  "padding-left_auto": "zzVUpa_padding-left_auto",
  "padding-left_desktop_1": "zzVUpa_padding-left_desktop_1",
  "padding-left_desktop_10": "zzVUpa_padding-left_desktop_10",
  "padding-left_desktop_14": "zzVUpa_padding-left_desktop_14",
  "padding-left_desktop_15": "zzVUpa_padding-left_desktop_15",
  "padding-left_desktop_2": "zzVUpa_padding-left_desktop_2",
  "padding-left_desktop_20": "zzVUpa_padding-left_desktop_20",
  "padding-left_desktop_25": "zzVUpa_padding-left_desktop_25",
  "padding-left_desktop_28": "zzVUpa_padding-left_desktop_28",
  "padding-left_desktop_3": "zzVUpa_padding-left_desktop_3",
  "padding-left_desktop_4": "zzVUpa_padding-left_desktop_4",
  "padding-left_desktop_5": "zzVUpa_padding-left_desktop_5",
  "padding-left_desktop_6": "zzVUpa_padding-left_desktop_6",
  "padding-left_desktop_7": "zzVUpa_padding-left_desktop_7",
  "padding-left_desktop_8": "zzVUpa_padding-left_desktop_8",
  "padding-left_desktop_9": "zzVUpa_padding-left_desktop_9",
  "padding-left_desktop_auto": "zzVUpa_padding-left_desktop_auto",
  "padding-left_desktop_gutter": "zzVUpa_padding-left_desktop_gutter",
  "padding-left_desktop_none": "zzVUpa_padding-left_desktop_none",
  "padding-left_gutter": "zzVUpa_padding-left_gutter",
  "padding-left_none": "zzVUpa_padding-left_none",
  "padding-left_tablet_1": "zzVUpa_padding-left_tablet_1",
  "padding-left_tablet_10": "zzVUpa_padding-left_tablet_10",
  "padding-left_tablet_14": "zzVUpa_padding-left_tablet_14",
  "padding-left_tablet_15": "zzVUpa_padding-left_tablet_15",
  "padding-left_tablet_2": "zzVUpa_padding-left_tablet_2",
  "padding-left_tablet_20": "zzVUpa_padding-left_tablet_20",
  "padding-left_tablet_25": "zzVUpa_padding-left_tablet_25",
  "padding-left_tablet_28": "zzVUpa_padding-left_tablet_28",
  "padding-left_tablet_3": "zzVUpa_padding-left_tablet_3",
  "padding-left_tablet_4": "zzVUpa_padding-left_tablet_4",
  "padding-left_tablet_5": "zzVUpa_padding-left_tablet_5",
  "padding-left_tablet_6": "zzVUpa_padding-left_tablet_6",
  "padding-left_tablet_7": "zzVUpa_padding-left_tablet_7",
  "padding-left_tablet_8": "zzVUpa_padding-left_tablet_8",
  "padding-left_tablet_9": "zzVUpa_padding-left_tablet_9",
  "padding-left_tablet_auto": "zzVUpa_padding-left_tablet_auto",
  "padding-left_tablet_gutter": "zzVUpa_padding-left_tablet_gutter",
  "padding-left_tablet_none": "zzVUpa_padding-left_tablet_none",
  "padding-right_1": "zzVUpa_padding-right_1",
  "padding-right_10": "zzVUpa_padding-right_10",
  "padding-right_14": "zzVUpa_padding-right_14",
  "padding-right_15": "zzVUpa_padding-right_15",
  "padding-right_2": "zzVUpa_padding-right_2",
  "padding-right_20": "zzVUpa_padding-right_20",
  "padding-right_25": "zzVUpa_padding-right_25",
  "padding-right_28": "zzVUpa_padding-right_28",
  "padding-right_3": "zzVUpa_padding-right_3",
  "padding-right_4": "zzVUpa_padding-right_4",
  "padding-right_5": "zzVUpa_padding-right_5",
  "padding-right_6": "zzVUpa_padding-right_6",
  "padding-right_7": "zzVUpa_padding-right_7",
  "padding-right_8": "zzVUpa_padding-right_8",
  "padding-right_9": "zzVUpa_padding-right_9",
  "padding-right_auto": "zzVUpa_padding-right_auto",
  "padding-right_desktop_1": "zzVUpa_padding-right_desktop_1",
  "padding-right_desktop_10": "zzVUpa_padding-right_desktop_10",
  "padding-right_desktop_14": "zzVUpa_padding-right_desktop_14",
  "padding-right_desktop_15": "zzVUpa_padding-right_desktop_15",
  "padding-right_desktop_2": "zzVUpa_padding-right_desktop_2",
  "padding-right_desktop_20": "zzVUpa_padding-right_desktop_20",
  "padding-right_desktop_25": "zzVUpa_padding-right_desktop_25",
  "padding-right_desktop_28": "zzVUpa_padding-right_desktop_28",
  "padding-right_desktop_3": "zzVUpa_padding-right_desktop_3",
  "padding-right_desktop_4": "zzVUpa_padding-right_desktop_4",
  "padding-right_desktop_5": "zzVUpa_padding-right_desktop_5",
  "padding-right_desktop_6": "zzVUpa_padding-right_desktop_6",
  "padding-right_desktop_7": "zzVUpa_padding-right_desktop_7",
  "padding-right_desktop_8": "zzVUpa_padding-right_desktop_8",
  "padding-right_desktop_9": "zzVUpa_padding-right_desktop_9",
  "padding-right_desktop_auto": "zzVUpa_padding-right_desktop_auto",
  "padding-right_desktop_gutter": "zzVUpa_padding-right_desktop_gutter",
  "padding-right_desktop_none": "zzVUpa_padding-right_desktop_none",
  "padding-right_gutter": "zzVUpa_padding-right_gutter",
  "padding-right_none": "zzVUpa_padding-right_none",
  "padding-right_tablet_1": "zzVUpa_padding-right_tablet_1",
  "padding-right_tablet_10": "zzVUpa_padding-right_tablet_10",
  "padding-right_tablet_14": "zzVUpa_padding-right_tablet_14",
  "padding-right_tablet_15": "zzVUpa_padding-right_tablet_15",
  "padding-right_tablet_2": "zzVUpa_padding-right_tablet_2",
  "padding-right_tablet_20": "zzVUpa_padding-right_tablet_20",
  "padding-right_tablet_25": "zzVUpa_padding-right_tablet_25",
  "padding-right_tablet_28": "zzVUpa_padding-right_tablet_28",
  "padding-right_tablet_3": "zzVUpa_padding-right_tablet_3",
  "padding-right_tablet_4": "zzVUpa_padding-right_tablet_4",
  "padding-right_tablet_5": "zzVUpa_padding-right_tablet_5",
  "padding-right_tablet_6": "zzVUpa_padding-right_tablet_6",
  "padding-right_tablet_7": "zzVUpa_padding-right_tablet_7",
  "padding-right_tablet_8": "zzVUpa_padding-right_tablet_8",
  "padding-right_tablet_9": "zzVUpa_padding-right_tablet_9",
  "padding-right_tablet_auto": "zzVUpa_padding-right_tablet_auto",
  "padding-right_tablet_gutter": "zzVUpa_padding-right_tablet_gutter",
  "padding-right_tablet_none": "zzVUpa_padding-right_tablet_none",
  "padding-top_1": "zzVUpa_padding-top_1",
  "padding-top_10": "zzVUpa_padding-top_10",
  "padding-top_14": "zzVUpa_padding-top_14",
  "padding-top_15": "zzVUpa_padding-top_15",
  "padding-top_2": "zzVUpa_padding-top_2",
  "padding-top_20": "zzVUpa_padding-top_20",
  "padding-top_25": "zzVUpa_padding-top_25",
  "padding-top_28": "zzVUpa_padding-top_28",
  "padding-top_3": "zzVUpa_padding-top_3",
  "padding-top_4": "zzVUpa_padding-top_4",
  "padding-top_5": "zzVUpa_padding-top_5",
  "padding-top_6": "zzVUpa_padding-top_6",
  "padding-top_7": "zzVUpa_padding-top_7",
  "padding-top_8": "zzVUpa_padding-top_8",
  "padding-top_9": "zzVUpa_padding-top_9",
  "padding-top_auto": "zzVUpa_padding-top_auto",
  "padding-top_desktop_1": "zzVUpa_padding-top_desktop_1",
  "padding-top_desktop_10": "zzVUpa_padding-top_desktop_10",
  "padding-top_desktop_14": "zzVUpa_padding-top_desktop_14",
  "padding-top_desktop_15": "zzVUpa_padding-top_desktop_15",
  "padding-top_desktop_2": "zzVUpa_padding-top_desktop_2",
  "padding-top_desktop_20": "zzVUpa_padding-top_desktop_20",
  "padding-top_desktop_25": "zzVUpa_padding-top_desktop_25",
  "padding-top_desktop_28": "zzVUpa_padding-top_desktop_28",
  "padding-top_desktop_3": "zzVUpa_padding-top_desktop_3",
  "padding-top_desktop_4": "zzVUpa_padding-top_desktop_4",
  "padding-top_desktop_5": "zzVUpa_padding-top_desktop_5",
  "padding-top_desktop_6": "zzVUpa_padding-top_desktop_6",
  "padding-top_desktop_7": "zzVUpa_padding-top_desktop_7",
  "padding-top_desktop_8": "zzVUpa_padding-top_desktop_8",
  "padding-top_desktop_9": "zzVUpa_padding-top_desktop_9",
  "padding-top_desktop_auto": "zzVUpa_padding-top_desktop_auto",
  "padding-top_desktop_gutter": "zzVUpa_padding-top_desktop_gutter",
  "padding-top_desktop_none": "zzVUpa_padding-top_desktop_none",
  "padding-top_gutter": "zzVUpa_padding-top_gutter",
  "padding-top_none": "zzVUpa_padding-top_none",
  "padding-top_tablet_1": "zzVUpa_padding-top_tablet_1",
  "padding-top_tablet_10": "zzVUpa_padding-top_tablet_10",
  "padding-top_tablet_14": "zzVUpa_padding-top_tablet_14",
  "padding-top_tablet_15": "zzVUpa_padding-top_tablet_15",
  "padding-top_tablet_2": "zzVUpa_padding-top_tablet_2",
  "padding-top_tablet_20": "zzVUpa_padding-top_tablet_20",
  "padding-top_tablet_25": "zzVUpa_padding-top_tablet_25",
  "padding-top_tablet_28": "zzVUpa_padding-top_tablet_28",
  "padding-top_tablet_3": "zzVUpa_padding-top_tablet_3",
  "padding-top_tablet_4": "zzVUpa_padding-top_tablet_4",
  "padding-top_tablet_5": "zzVUpa_padding-top_tablet_5",
  "padding-top_tablet_6": "zzVUpa_padding-top_tablet_6",
  "padding-top_tablet_7": "zzVUpa_padding-top_tablet_7",
  "padding-top_tablet_8": "zzVUpa_padding-top_tablet_8",
  "padding-top_tablet_9": "zzVUpa_padding-top_tablet_9",
  "padding-top_tablet_auto": "zzVUpa_padding-top_tablet_auto",
  "padding-top_tablet_gutter": "zzVUpa_padding-top_tablet_gutter",
  "padding-top_tablet_none": "zzVUpa_padding-top_tablet_none",
  "position_absolute": "zzVUpa_position_absolute",
  "position_desktop_absolute": "zzVUpa_position_desktop_absolute",
  "position_desktop_fixed": "zzVUpa_position_desktop_fixed",
  "position_desktop_relative": "zzVUpa_position_desktop_relative",
  "position_desktop_static": "zzVUpa_position_desktop_static",
  "position_desktop_sticky": "zzVUpa_position_desktop_sticky",
  "position_fixed": "zzVUpa_position_fixed",
  "position_relative": "zzVUpa_position_relative",
  "position_static": "zzVUpa_position_static",
  "position_sticky": "zzVUpa_position_sticky",
  "position_tablet_absolute": "zzVUpa_position_tablet_absolute",
  "position_tablet_fixed": "zzVUpa_position_tablet_fixed",
  "position_tablet_relative": "zzVUpa_position_tablet_relative",
  "position_tablet_static": "zzVUpa_position_tablet_static",
  "position_tablet_sticky": "zzVUpa_position_tablet_sticky",
  "text-align_center": "zzVUpa_text-align_center",
  "text-align_desktop_center": "zzVUpa_text-align_desktop_center",
  "text-align_desktop_left": "zzVUpa_text-align_desktop_left",
  "text-align_desktop_right": "zzVUpa_text-align_desktop_right",
  "text-align_left": "zzVUpa_text-align_left",
  "text-align_right": "zzVUpa_text-align_right",
  "text-align_tablet_center": "zzVUpa_text-align_tablet_center",
  "text-align_tablet_left": "zzVUpa_text-align_tablet_left",
  "text-align_tablet_right": "zzVUpa_text-align_tablet_right",
  "user-select_none": "zzVUpa_user-select_none",
  "width_full": "zzVUpa_width_full",
  "width_touchable": "zzVUpa_width_touchable",
});
